import React, {useState} from "react";
import {
    Button,
    Divider,
    FormControlLabel,
    FormGroup,
    IconButton,
    Stack,
    Switch,
    ToggleButton,
    Tooltip
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import CodeIcon from "@mui/icons-material/Code";
import FeedbackIcon from '@mui/icons-material/Feedback';
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export default function ActionsComponent(props) {
    const [showActions, setShowActions] = useState(true);

    function handleShowActions() {
        setShowActions(!showActions)
    }

    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        let tempShowSolution = !showSolution;
        setShowSolution(tempShowSolution)
        props.onToggleShowSolution(tempShowSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        let tempShowFeedback = !showFeedback;
        setShowFeedback(tempShowFeedback)
        props.onToggleShowFeedback(tempShowFeedback)
    }

    return (
        <>
            <p></p>
            {/*<Stack*/}
            {/*    width="fit-content"*/}
            {/*    direction="row"*/}
            {/*    spacing={2}*/}
            {/*    component="div"*/}
            {/*    sx={{marginTop: '1em', padding: '0em', bgcolor: "#f9f9f9", border: "1px solid #ccc"}}*/}
            {/*>*/}

            {/*    {showActions*/}
            {/*        ?*/}
            {/*        <Tooltip*/}
            {/*            title={"Aktionen verbergen"}*/}
            {/*        >*/}
            {/*            <KeyboardArrowUpIcon*/}
            {/*                size="small"*/}
            {/*                color="primary"*/}
            {/*                onClick={handleShowActions}/>*/}
            {/*        </Tooltip>*/}
            {/*        :*/}
            {/*        <Tooltip*/}
            {/*            title={"Aktionen anzeigen"}*/}
            {/*        >*/}
            {/*            <KeyboardArrowDownIcon*/}
            {/*                size="small"*/}
            {/*                color="primary"*/}
            {/*                onClick={handleShowActions}/>*/}
            {/*        </Tooltip>*/}

            {/*    }*/}
            {/*</Stack>*/}
            {/*{*/}
            {/*    showActions &&*/}
            {/*    <Stack*/}
            {/*        width="fit-content"*/}
            {/*        direction="row"*/}
            {/*        spacing={2}*/}
            {/*        component="div"*/}
            {/*        sx={{marginTop: '0em', padding: '0.3em', bgcolor: "#f9f9f9", border: "1px solid #eee"}}*/}
            {/*    >*/}
            {/*        /!*<Divider flexItem orientation="vertical"></Divider>*!/*/}
            {/*        <Tooltip*/}
            {/*            title={"Hilfe anzeigen"}*/}
            {/*        >*/}
            {/*            <IconButton*/}
            {/*                onClick={props.toggleDrawHilfe}*/}
            {/*                variant="outlined"*/}
            {/*                sx={{*/}
            {/*                    minHeight: 0,*/}
            {/*                    minWidth: 0,*/}
            {/*                    textTransform: 'none',*/}
            {/*                    padding: '0px 5px 0px 5px'*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                <HelpIcon/>*/}
            {/*            </IconButton>*/}
            {/*        </Tooltip>*/}
            {/*        <Tooltip*/}
            {/*            title={"JSON anzeigen"}*/}
            {/*        >*/}
            {/*            <IconButton*/}
            {/*                onClick={props.toggleDrawJSON}*/}
            {/*                variant="outlined"*/}
            {/*                sx={{*/}
            {/*                    minHeight: 0,*/}
            {/*                    minWidth: 0,*/}
            {/*                    textTransform: 'none',*/}
            {/*                    padding: '0px 5px 0px 5px'*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                <CodeIcon/>*/}
            {/*            </IconButton>*/}
            {/*        </Tooltip>*/}
            {/*        {*/}
            {/*            props.exercise.sentencenr &&*/}
            {/*            <Tooltip*/}
            {/*                title={"Lesetext anzeigen"}*/}
            {/*            >*/}
            {/*        <span><IconButton*/}
            {/*            onClick={props.toggleDrawLesetext}*/}
            {/*            variant="contained"*/}
            {/*            disabled={!props.exercise.sentencenr}*/}
            {/*            sx={{*/}
            {/*                minHeight: 0,*/}
            {/*                minWidth: 0,*/}
            {/*                textTransform: 'none',*/}
            {/*                padding: '0px 5px 0px 5px'*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <TextSnippetIcon/>*/}
            {/*        </IconButton></span>*/}
            {/*            </Tooltip>*/}
            {/*        }*/}
            {/*        <Divider flexItem orientation="vertical"></Divider>*/}
            {/*        <Tooltip*/}
            {/*            title={"Feedback anzeigen"}*/}
            {/*        >*/}
            {/*            <ToggleButton*/}
            {/*                onChange={handleShowFeedback}*/}
            {/*                value="Feedback"*/}
            {/*                color="primary"*/}
            {/*                size="small"*/}
            {/*                selected={showFeedback}*/}
            {/*                sx={{border: 'none', margin: 0, padding: 0}}*/}
            {/*            >*/}
            {/*                <FeedbackIcon/>*/}
            {/*            </ToggleButton>*/}
            {/*        </Tooltip>*/}
            {/*        <Tooltip*/}
            {/*            title={"Lösung anzeigen"}*/}
            {/*        >*/}
            {/*            <ToggleButton*/}
            {/*                onChange={handleShowSolution}*/}
            {/*                value="Loesung"*/}
            {/*                color="primary"*/}
            {/*                size="small"*/}
            {/*                selected={showSolution}*/}
            {/*                sx={{border: 'none', margin: 0, padding: 0}}*/}
            {/*            >*/}
            {/*                <EmojiObjectsIcon/>*/}
            {/*            </ToggleButton>*/}
            {/*        </Tooltip>*/}
            {/*        /!*<Divider flexItem orientation="vertical"></Divider>*!/*/}
            {/*    </Stack>*/}
            {/*}*/}
            {
                showActions &&
                <Stack
                    width="fit-content"
                    direction="row"
                    spacing={2}
                    component="div"
                    sx={{marginTop: '0em', padding: '0.3em', bgcolor: "#f9f9f9", border: "1px solid #ccc"}}
                >
                    {/*<Divider flexItem orientation="vertical"></Divider>*/}
                    {/*<Tooltip*/}
                    {/*    title={"Hilfe anzeigen"}*/}
                    {/*>*/}
                    {/*    <Button*/}
                    {/*        startIcon={<HelpIcon/>}*/}
                    {/*        onClick={props.toggleDrawHilfe}*/}
                    {/*        variant="text"*/}
                    {/*        sx={{*/}
                    {/*            minHeight: 0,*/}
                    {/*            minWidth: 0,*/}
                    {/*            textTransform: 'none',*/}
                    {/*            padding: '0px 5px 0px 5px',*/}
                    {/*            borderColor: "#666",*/}
                    {/*            color: "#666",*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        Hilfe*/}
                    {/*    </Button>*/}
                    {/*</Tooltip>*/}
                    {/*<Divider flexItem sx={{borderColor: "#ccc"}} orientation="vertical"></Divider>*/}
                    {/*<Tooltip*/}
                    {/*    title={"JSON anzeigen"}*/}
                    {/*>*/}
                    {/*    <Button*/}
                    {/*        startIcon={<CodeIcon/>}*/}
                    {/*        onClick={props.toggleDrawJSON}*/}
                    {/*        variant="text"*/}
                    {/*        sx={{*/}
                    {/*            minHeight: 0,*/}
                    {/*            minWidth: 0,*/}
                    {/*            textTransform: 'none',*/}
                    {/*            padding: '0px 5px 0px 5px',*/}
                    {/*            borderColor: "#999",*/}
                    {/*            color: "#999",*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        JSON*/}
                    {/*    </Button>*/}
                    {/*</Tooltip>*/}
                    <Divider flexItem orientation="vertical"></Divider>
                    {
                        props.exercise.sentencenr &&
                            <>
                        <Tooltip
                            title={"Lesetext anzeigen"}
                        >
                    <span><Button
                        startIcon={<TextSnippetIcon/>}
                        onClick={props.toggleDrawLesetext}
                        variant="text"
                        disabled={!props.exercise.sentencenr}
                        sx={{
                            minHeight: 0,
                            minWidth: 0,
                            textTransform: 'none',
                            padding: '0px 5px 0px 5px',
                            borderColor: "#666",
                            color: "#666",
                        }}
                    >
                        Lesetext
                    </Button></span>
                        </Tooltip>
                        <Divider flexItem sx={{borderColor: "#ccc"}} orientation="vertical"></Divider>
                        </>
                    }
                    <FormGroup row>
                        <Tooltip
                            title={"Feedback anzeigen"}
                        >
                            <FormControlLabel
                                control={
                                    <Switch
                                        onChange={handleShowFeedback}
                                        checked={showFeedback}
                                        size="small"

                                    />
                                }
                                label={<span style={{ fontSize: '90%' }}>Feedback</span>}
                                sx={{color: "#666"}}
                            />
                        </Tooltip>
                        <Tooltip
                            title={"Lösung anzeigen"}
                        >
                            <FormControlLabel
                                control={
                                    <Switch
                                        onChange={handleShowSolution}
                                        checked={showSolution}
                                        size="small"
                                    />
                                }
                                label={<span style={{ fontSize: '90%' }}>Lösung</span>}
                                sx={{color: "#666"}}
                            />
                        </Tooltip>
                    <Divider flexItem orientation="vertical"></Divider>
                    </FormGroup>
                    {/*<Divider flexItem orientation="vertical"></Divider>*/}
                </Stack>
            }
        </>
    )
}